export * from 'server/models/PSixServiceSearch';


// WEBPACK FOOTER //
// ./data/models/PSixServiceSearch.ts